// import 'froala-editor/js/froala_editor.pkgd.min.js';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgProgressModule } from 'ngx-progressbar';
import { TreeviewModule } from 'ngx-treeview';

import { AdsModule } from '../adcomponents/ad.module';
import { CmsRoutingModule } from './cms-routing.module';
import { CmsStudioService } from './cms-studio.service';
import { CmsViewDirectiveComponent } from './cmsdirectives/cmsviewdirective.component';
import { CmsStudioComponent } from './cmsstudio/cmsstudio.component';
import { CmspreviewComponent } from './cmsview/cmspreview.component';
import { CmsViewComponent } from './cmsview/cmsview.component';
import { CmsViewChildComponent } from './cmsview/cmsviewchild.component';
import { CmsViewDirectiveService } from './cmsdirectives/cmsviewdirective.service';
import { CmsComponent } from './cms.component';
import { SharedModule } from '../shared/shared.module';
import { CmsTreeviewComponent } from './cmstreeview/cmstreeview.component';
import { ClipboardModule } from 'ngx-clipboard';
import { CmsAccessComponent } from './cmsaccess/cmsaccess.component';
//import { SanitizeHtmlPipe } from '../shared/sanitize-html.pipe';
import { DragulaModule } from 'ng2-dragula';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { AdminAuthGuard } from '../admin/admin.authguard';


@NgModule({
  imports: [
    CommonModule,
    CmsRoutingModule,    
    FormsModule,
    AdsModule,
    NgProgressModule,
    NgxPaginationModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    TreeviewModule.forRoot(),
    SharedModule,
    ClipboardModule,
    DragulaModule.forRoot(),
    ChildHeaderModule,
    BreadcrumbModule
  ],
  declarations: [
    CmsStudioComponent,     
    CmsViewComponent,
    CmspreviewComponent,
    CmsViewChildComponent,
    //SanitizeHtmlPipe,
    CmsViewDirectiveComponent,
    CmsComponent,
    CmsTreeviewComponent  ,
    CmsAccessComponent  
  ],  
  providers: [CmsStudioService, CmsViewDirectiveService, AdminAuthGuard],
  entryComponents: [CmsViewDirectiveComponent]
})
export class CmsStudioModule {}
